export default __webpack_public_path__ + "static/logo-ecb86fdbc5b758b32f2c96e024c27a8a.png";